import { useTranslation } from 'react-i18next';

const RenderTicketCategory = ({ category }: { category?: 'IN' | 'OUT' | 'DELIVERY' }) => {
  const { t } = useTranslation();

  switch (category) {
    case 'IN':
      return t('common:dine_in');
    case 'OUT':
      return t('common:takeaway');
    case 'DELIVERY':
      return t('common:delivery');
    default:
      return t('common:no_category');
  }
};

export default RenderTicketCategory;
